import MarkoResume from "../../Marko-Novakovic-resume.pdf";
import CirclePdfLink from "../CirclePdfLink";

export default function Resume() {
  return (
    <div className="experience container">
      <h1 className="page-title">Experience</h1>
      <h2>WORKPLACES</h2>
      <CirclePdfLink pdfLink={MarkoResume} />
      <div className="experience-wrapper">
        <div className="experience-left">
          <h3>Glimmernet Technologies, Bethesda, MD</h3>
          <p>
            <strong>Web developer & designer</strong>
          </p>
          <p>(Aug 2017 - Present)</p>
          <ul>
            <li>
              <strong>Project Management & Development Leadership: </strong>
              Successfully manage a diverse portfolio of over 70 website
              development projects, showcasing adaptability and expertise across
              various industries and client requirements. Lead the full life
              cycle of website development projects, overseeing from conception
              to deployment, ensuring seamless execution and client
              satisfaction.
            </li>
            <li>
              <strong>Client Communication & Satisfaction: </strong>
              Maintain a reputation for delivering exceptional work, effective
              communication, and timely solutions, consistently achieving high
              levels of client satisfaction. Proactively engage with clients to
              understand their needs and ensure precise execution of all
              requests.
            </li>
            <li>
              <strong>Technical Expertise: </strong>Design and develop
              responsive websites using WordPress, employing HTML5, CSS3,
              JavaScript, and PHP to ensure cross-browser compatibility and
              optimal user experience.
            </li>
            <li>
              <strong>Responsive Design & Cross-Browser Compatibility: </strong>
              Develop responsive websites optimized for multiple screen sizes
              and ensure compatibility across various browsers, ensuring a
              seamless user experience regardless of device or platform.
            </li>
            <li>
              <strong>Design Integration: </strong>Transform design concepts
              from Photoshop files or Figma into functional websites, ensuring
              fidelity to the original vision while optimizing for web
              performance.
            </li>
            <li>
              <strong>Project Estimation & Consultation: </strong>Provide
              accurate project time estimates, balancing client expectations
              with realistic development timelines.
            </li>
            <li>
              <strong>Bug Fixing & Performance Enhancement: </strong>Implement
              bug fixes and performance enhancements on existing websites,
              significantly improving functionality and speed.
            </li>
            <li>
              <strong>Presentation & Client Engagement: </strong>Conduct
              presentations and demos to showcase project progress, maintaining
              transparent communication and keeping clients informed throughout
              the development process.
            </li>
          </ul>
          <br />
          <h3>HORISEN Marketing Technology, Niš, Serbia</h3>
          <p>
            <strong>Front-end developer</strong>
          </p>
          <p>(Dec 2013 – May 2017)</p>
          <ul>
            <li>
              Developed mobile-first dynamic and interactive websites from PSD
              files that increased page visits and sales revenue.
            </li>
            <li>Created website layouts using CSS framework (Bootstrap).</li>
            <li>
              Implemented functionalities to websites using JavaScript (jQuery).
            </li>
            <li>
              Maintained old websites (updated content and applied new designs
              and functionalities).
            </li>
            <li>
              Designed a dashboard for the company's custom Content Management
              System (CMS).
            </li>
            <li>
              Made content changes in MySQL database and created update scripts.
            </li>
            <li>Mentored a new developer joining the team.</li>
          </ul>
        </div>
        <div className="experience-right">
          <h3>Technical skills:</h3>
          <ul>
            <li>HTML5</li>
            <li>CSS3 (SASS, Tailwind)</li>
            <li>JavaScript (ReactJS, NodeJS, jQuery)</li>
            <li>GraphQL</li>
            <li>MongoDB</li>
            <li>Cross browser compatibility</li>
            <li>Responsive web development</li>
            <li>BEM methodology</li>
          </ul>

          <h3>Tools:</h3>
          <ul>
            <li>Version control software (Git and SVN)</li>
            <li>FTP clients (FileZilla or WinSCP)</li>
            <li>Task runners (Grunt, Gulp)</li>
            <li>Adobe Photoshop and Adobe Illustrator</li>
          </ul>

          <h3>Languages:</h3>
          <ul>
            <li>English (fluent)</li>
            <li>Serbian (native)</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
